module.exports = __webpack_public_path__ + "img/1f37b.c5a62f2.svg";